
export default [
  // {
  //   header: '—— แต้มสะสม ——',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'แต้มสะสม',
  //   route: 'point-balance',
  //   icon: 'StarIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
  // {
  //   title: 'แลกแต้ม',
  //   route: 'exchange-point',
  //   icon: 'AwardIcon',
  //   resource: 'normal',
  //   action: 'manage',
  // },
]
